import { useQuery } from '@tanstack/react-query';
import sportsApi from '../../utils/sportsApi';

const key = 'ClientRightsholders';

type RightsholderInput = {
    clientId: number;
};

const fetchRightsholders = async (clientId: number) => {
    const response = await sportsApi
        .url(`/clients/${clientId}/rightsholders`)
        .get()
        .json();
    return response;
};

const useRightsholders = ({ clientId }: RightsholderInput) =>
    useQuery({
        queryKey: [key, clientId],
        queryFn: () => fetchRightsholders(clientId),
    });

export default useRightsholders;
